<template>
  <div v-if="$can('viewProjectItem')" class="buttonCt">
    <a :href="`/push/campaign/active?project_id=${projectId}`">
      <el-button type="primary" plain>
        {{ $t('ProjectOverview_ViewLiveCampaigns') }}
      </el-button>
    </a>
    <router-link
      v-if="$can('createProjectItem')"
      :to="`/push/campaign/create?project_id=${projectId}&workflow=${workflow}`"
    >
      <el-button type="primary" plain>
        {{ $t('ProjectOverview_CreateNewCampaign') }}
      </el-button>
    </router-link>
    <router-link
      v-else-if="$can('sendPushCampaign')"
      :to="`/push/campaign/approve?project_id=${projectId}`"
    >
      <el-button type="primary" plain>
        {{ $t('ProjectOverview_ApproveCampaigns') }}
      </el-button>
    </router-link>

    <a v-else :href="`/push/campaign/past?project_id=${projectId}`">
      <el-button type="primary" plain>
        {{ $t('ProjectOverview_ViewPastCampaigns') }}
      </el-button>
    </a>

    <a :href="`/analytics/analytics/index?project_id=${projectId}`">
      <el-button class="viewProjectBtn" type="primary">
        {{ $t('ProjectOverview_ViewProject') }}
      </el-button>
    </a>
  </div>

  <div v-else class="buttonCt">
    <a
      v-if="$can('CampaignTemplate::Read')"
      :href="`/push/campaign-template/index?project_id=${projectId}`"
    >
      <el-button type="primary" plain>
        {{ $t('ProjectOverview_Templates') }}
      </el-button>
    </a>

    <router-link
      v-if="$can('ContentSnippet::Read')"
      :to="`/content/snippet/index?project_id=${projectId}`"
    >
      <el-button type="primary" plain>
        {{ $t('ProjectOverview_Snippets') }}
      </el-button>
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'ProjectOverviewButtons',

  props: {
    projectId: {
      type: Number,
      required: true
    },
    workflow: {
      type: Number
    }
  }
}
</script>
<style scoped>
.buttonCt {
  margin-bottom: 5px;
}

button {
  padding: 6px 12px;
  font-size: 12px;
  line-height: 18px;
  color: #a6a6a6;
  margin-right: 10px;
}

.viewProjectBtn {
  margin-right: 0;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ProjectOverviewButtons.vue